import { Toaster as Sonner, toast as sonnerToast } from "sonner";

// Toasts confirm a SUCCESS that the page does not show anywhere else ("Request accepted"). Errors, refusals and conflicts stay inline,
// next to the thing that failed, where a screen reader and the next retry can find them: they never go to a toast. So this module offers
// `toast.success` and nothing for failures. Text is fixed wording; never customer text.

/** Mount once, in the shell. */
export function Toaster() {
  return (
    <Sonner
      theme="light"
      position="bottom-right"
      closeButton
      duration={5000}
      toastOptions={{
        classNames: {
          toast:
            "border-border! bg-popover! text-popover-foreground! shadow-lg! rounded-md! font-sans!",
          description: "text-muted-foreground!",
          closeButton: "border-border! bg-popover! text-foreground!",
        },
      }}
    />
  );
}

export const toast = {
  /** A polite confirmation (`role="status"`). */
  success(message: string): void {
    sonnerToast.success(message);
  },
  dismiss(): void {
    sonnerToast.dismiss();
  },
};
